<template>
  <div
    v-if="!isDismissed"
    class="px-6 pb-4"
    data-testid="flows-private-space-banner"
  >
    <div class="flex justify-between gap-4 rounded-lg border border-warning bg-warning p-4">
      <div class="flex items-start gap-2">
        <Icon
          type="lock"
          class="mt-0.5 h-4 w-4 shrink-0 text-warning-emphasis"
        />
        <div>
          <p class="font-medium text-warning-emphasis mb-0">
            You have Flows and/or Linked Apps which are only visible to you in your Private Flows area
          </p>
          <p class="text-sm text-warning-emphasis mb-0">
            You can now make them available to Shared Builders for this app by recreating them in this Shared Flows area.
          </p>
        </div>
      </div>
      <div class="flex shrink-0 items-center gap-3">
        <a
          href="https://docs.knack.com/docs/flows-getting-started"
          class="font-medium underline text-warning-emphasis"
          target="_blank"
          rel="noreferrer"
        >
          Need help recreating Flows?
        </a>
        <button
          type="button"
          aria-label="Dismiss"
          class="bg-transparent inline-flex cursor-pointer p-0 border-none"
          @click="dismiss"
        >
          <Icon
            type="close"
            class="h-4 w-4 text-warning-emphasis"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/ui/Icon.vue';

function getStorageKey(accountSlug, appSlug) {
  return `flows_banner_dismissed_both_${accountSlug}_${appSlug}`;
}

export default {
  name: 'FlowsPrivateSpaceBanner',
  components: { Icon },
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    ...mapGetters(['accountSlug', 'appSlug']),
    storageKey() {
      return getStorageKey(this.accountSlug, this.appSlug);
    },
  },
  created() {
    this.isDismissed = localStorage.getItem(this.storageKey) === 'true';
  },
  methods: {
    dismiss() {
      localStorage.setItem(this.storageKey, 'true');
      this.isDismissed = true;
    },
  },
};
</script>
